export const Style = ({ colors = [] }) => (
  <g id="Estilo1" style={{ opacity: '0.6' }}>
    <path
      style={{ display: 'inline', fill: colors[0] }}
      d="M70.2,72c0,0,5.3,2.7,10.7,0c0,0,1.1-3.7-5.3-3.7C69.3,68.3,70.2,72,70.2,72z"
    />
  </g>
)
